(function(){
  var VERSION = '2026-07-14-live-stock-v1';

  function toNumber(value, fallback){
    var parsed = parseInt(value, 10);
    return isNaN(parsed) ? fallback : parsed;
  }

  function getSection(element){
    return element && element.closest ? element.closest('[data-section-type="product"]') : null;
  }

  function getSelectedVariantOption(section){
    if(!section) return null;
    var select = section.querySelector('select.product-form__variants[name="id"], select[name="id"].product-form__variants');
    if(!select || select.selectedIndex < 0) return null;
    return select.options[select.selectedIndex] || null;
  }

  function getInventory(section){
    var option = getSelectedVariantOption(section);
    if(!option) return null;

    var management = option.getAttribute('data-inventory_management') || '';
    var policy = option.getAttribute('data-inventory_policy') || '';
    var quantity = Math.max(0, toNumber(option.getAttribute('data-inventory_quantity'), 0));
    var availableAttr = option.getAttribute('data-variant_available');
    var available = availableAttr === null ? quantity > 0 || policy === 'continue' : availableAttr === 'true';

    return {
      management: management,
      policy: policy,
      quantity: quantity,
      available: available,
      limited: !!management && management !== 'null' && policy === 'deny'
    };
  }

  function syncButtons(section, input, inventory){
    var wrap = input ? input.closest('.qty') : null;
    if(!wrap) return;

    var value = Math.max(1, toNumber(input.value, 1));
    var minus = wrap.querySelector('.minus_btn');
    var plus = wrap.querySelector('.plus_btn');
    var plusDisabled = !inventory || !inventory.available || (inventory.limited && value >= inventory.quantity);
    var minusDisabled = !inventory || !inventory.available || value <= 1;

    if(minus){
      minus.classList.toggle('is-disabled', minusDisabled);
      minus.setAttribute('aria-disabled', minusDisabled ? 'true' : 'false');
    }
    if(plus){
      plus.classList.toggle('is-disabled', plusDisabled);
      plus.setAttribute('aria-disabled', plusDisabled ? 'true' : 'false');
    }
  }

  function updateLowStock(section, inventory){
    var message = section ? section.querySelector('[data-hpr-low-stock]') : null;
    if(!message) return;

    var threshold = Math.max(1, toNumber(message.getAttribute('data-threshold'), 20));
    var shouldShow = !!inventory && inventory.available && inventory.limited && inventory.quantity > 0 && inventory.quantity <= threshold;
    message.hidden = !shouldShow;

    if(shouldShow){
      var count = message.querySelector('[data-hpr-low-stock-count]');
      if(count) count.textContent = inventory.quantity;
    }
  }

  function normalizeInput(section, input, commit){
    if(!section || !input) return;
    var inventory = getInventory(section);
    var raw = String(input.value || '').replace(/[^0-9]/g, '');

    if(!raw && !commit){
      input.value = '';
      syncButtons(section, input, inventory);
      return;
    }

    var value = Math.max(1, toNumber(raw, 1));
    if(inventory && inventory.limited && inventory.quantity > 0){
      value = Math.min(value, inventory.quantity);
    }
    input.value = value;
    syncButtons(section, input, inventory);
  }

  function updateSection(section){
    if(!section) return;
    var input = section.querySelector('[data-quantity-input]');
    var inventory = getInventory(section);

    if(input){
      if(inventory && inventory.limited && inventory.quantity > 0){
        input.setAttribute('max', inventory.quantity);
      } else {
        input.removeAttribute('max');
      }

      var unavailable = !inventory || !inventory.available || (inventory.limited && inventory.quantity <= 0);
      input.disabled = unavailable;

      if(!unavailable){
        normalizeInput(section, input, true);
      } else {
        input.value = 1;
        syncButtons(section, input, inventory);
      }
    }

    updateLowStock(section, inventory);
  }

  function initAll(root){
    root = root || document;
    var sections = root.matches && root.matches('[data-section-type="product"]') ? [root] : root.querySelectorAll('[data-section-type="product"]');
    Array.prototype.forEach.call(sections, updateSection);
  }

  if(!window.HPRInventoryControls || window.HPRInventoryControls.version !== VERSION){
    window.HPRInventoryControls = {version: VERSION, initAll: initAll, updateSection: updateSection};

    document.addEventListener('click', function(event){
      var button = event.target.closest ? event.target.closest('.product-page-qty .qty_btn') : null;
      if(!button) return;

      var section = getSection(button);
      var input = button.closest('.qty').querySelector('[data-quantity-input]');
      if(!section || !input) return;

      event.preventDefault();
      event.stopPropagation();
      if(typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();

      var inventory = getInventory(section);
      if(!inventory || !inventory.available) return;

      var value = Math.max(1, toNumber(input.value, 1));
      if(button.classList.contains('minus_btn')){
        value = Math.max(1, value - 1);
      } else if(!(inventory.limited && value >= inventory.quantity)) {
        value += 1;
      }

      if(inventory.limited && inventory.quantity > 0){
        value = Math.min(value, inventory.quantity);
      }
      input.value = value;
      syncButtons(section, input, inventory);
      input.dispatchEvent(new Event('change', {bubbles: true}));
    }, true);

    document.addEventListener('input', function(event){
      if(!event.target.matches || !event.target.matches('[data-quantity-input]')) return;
      normalizeInput(getSection(event.target), event.target, false);
    }, true);

    document.addEventListener('change', function(event){
      if(!event.target.matches || !event.target.matches('[data-quantity-input]')) return;
      normalizeInput(getSection(event.target), event.target, true);
    }, true);

    document.addEventListener('blur', function(event){
      if(!event.target.matches || !event.target.matches('[data-quantity-input]')) return;
      normalizeInput(getSection(event.target), event.target, true);
    }, true);

    document.addEventListener('variantChange', function(event){
      var section = getSection(event.target) || (event.target.matches && event.target.matches('[data-section-type="product"]') ? event.target : null);
      if(section) updateSection(section);
    });

    document.addEventListener('shopify:section:load', function(event){ initAll(event.target || document); });

    if(document.readyState === 'loading'){
      document.addEventListener('DOMContentLoaded', function(){ initAll(document); });
    } else {
      initAll(document);
    }
  } else if(typeof window.HPRInventoryControls.initAll === 'function') {
    window.HPRInventoryControls.initAll(document);
  }
})();
